import React from "react";
import { Switch } from "react-router-dom";
import { useSelector } from "react-redux";

import { ProtectedRoute } from "./privateRoute";
import VerifyQuote from "../Pages/verifyQuote";
import { ApproveQuote } from "../Pages/wizard/ApproveQuote";
import ErrorPage from "../Pages/wizard/ErrorPage";
import { OffLine } from "../Pages/wizard/OffLine";
import ListAprovations from "../Pages/listAprovations";

function NestedRoutersAprovations({ path }) {
  const modules = useSelector((state) => state.login.access_configuration.modules);
  const granted = useSelector((state) => state.login.granted);

  return (
    <Switch>
      <ProtectedRoute
        exact
        path={path}
        component={ListAprovations}
        modules={modules}
        granted={granted}
      />
      <ProtectedRoute
        exact
        path={path + "/verificacion"}
        component={VerifyQuote}
        modules={modules}
        granted={granted}
      />
      <ProtectedRoute
        exact
        path={path + "/aprobacion"}
        component={ApproveQuote}
        modules={modules}
        granted={granted}
      />

      <ProtectedRoute
        exact
        path={path + "/error-simulacion"}
        component={ErrorPage}
        modules={modules}
        granted={granted}
      />
      <ProtectedRoute
        exact
        path={path + "/sin-conexion"}
        component={OffLine}
        modules={modules}
        granted={granted}
      />
    </Switch>
  );
}

export default NestedRoutersAprovations;
